<template>
    <v-autocomplete
        ref="combobox_2"
        v-model="hospClin"
        :readonly="disableElementsReq"
        clearable
        prefix="DR."
        color="teal"
        label="Full Name of Doctor"
        :items="getReqDoctors"
        item-text="doc_name"
        return-object
        autocomplete="nope"
        :rules="disableElementsReq ? [()=>true] : rules.doctorRules"
        @change="handleChangeReqHospClinDoctor($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title style="color: black;">
                    {{ item.doc_name }}
                </v-list-item-title>
                <v-list-item-subtitle style="font-size: 12px">
                    {{
                        [
                            item.doc_specialization_1,
                            item.doc_specialization_2,
                            item.doc_specialization_3
                        ]
                            .filter(Boolean)
                            .join(' • ')
                    }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['disableElementsReq', 'req'],
    data: ()=>({
        hospClin: null,
        rules: {
            doctorRules: [v => !!v || 'This field is required!', v => v != null && /^[A-z|0-9]+/.test(v.trim()) || 'Invalid input!']
        }
    }),
    computed: {
        ...mapGetters(['getReqDoctors'])
    },
    watch: {
        'req.hospClinDoctor': {
            handler(newVal) {
                this.hospClin = newVal
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleChangeReqHospClinDoctor(value) {
            this.req.hospClinDoctor = value && value.doc_name
            this.req.hospClinDoctorCode = value && value.doc_id
        }
    }
}
</script>
